import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { withStyles } from '@material-ui/core/styles'

import { authLogin } from '../../redux/ducks/auth';
import api from '../../services/api';
import { Container, Espacobase } from './styles';

import Input        from '../../components/Input';
import BotaoPadrao  from '../../components/BotaoPadrao';
import StdTextField from '../../components/StdTextField';
import StdButton    from '../../components/StdButton';

import * as yup from 'yup';
let schema = yup.object().shape({
  email: yup.string().email().required(),
  password: yup.string().required(),
});

const StyledTextField = withStyles({
  root: { width: '100%' }
})(StdTextField)

function Login() {
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  function handleSubmit() {
    setLoading(true);
    schema
      .validate({
        email: email,
        password: password,
      })
      .then(async () => {
        const { data } = await api.post('/authenticate', {
          email: email,
          password: password,
        });
        setLoading(false);
        dispatch(authLogin(data.token));
      })
      .catch(() => setLoading(false))
  }

  return <Container>
    <h1>Acesso ao painel</h1>
    <StyledTextField
      label='Email'
      value={email}
      onChange={e => setEmail(e.target.value)}
    />
    <StyledTextField
      type='password'
      label='Senha'
      value={password}
      onChange={e => setPassword(e.target.value)}
    />
    <StdButton onClick={() => handleSubmit()}>
      { loading ? '...' : 'ENTRAR'}
    </StdButton>
  </Container>;
}

export default Login;
